'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRESENTATIONAL_MESSAGE_TYPES = exports.CONVERSATIONAL_MESSAGE_TYPES = exports.AUTOMATED_CHAT_MESSAGE_TYPES = undefined;

var _immutable = require('immutable');

var _messageTypes = require('./messageTypes');

var _messageTypes2 = require('../../unpublished-messages/constants/messageTypes');

var _messageTypes3 = require('../../common-message-format/constants/messageTypes');

var AUTOMATED_CHAT_MESSAGE_TYPES = exports.AUTOMATED_CHAT_MESSAGE_TYPES = (0, _immutable.List)([_messageTypes.EMAIL_CAPTURE_PROMPT, _messageTypes.EMAIL_CAPTURE_RESPONSE, _messageTypes.OFFICE_HOURS, _messageTypes.TYPICAL_RESPONSE_TIME, _messageTypes.CHAT_RICH_TEMPLATE]);

var CONVERSATIONAL_MESSAGE_TYPES = exports.CONVERSATIONAL_MESSAGE_TYPES = (0, _immutable.List)([_messageTypes.INITIAL_MESSAGE, _messageTypes.CHAT_MESSAGE, _messageTypes.OFFLINE, _messageTypes.THREAD_COMMENT, _messageTypes3.COMMON_MESSAGE, _messageTypes2.ACTIVELY_PUBLISHING, _messageTypes2.FAILED_TO_PUBLISH]).concat(AUTOMATED_CHAT_MESSAGE_TYPES);

var PRESENTATIONAL_MESSAGE_TYPES = exports.PRESENTATIONAL_MESSAGE_TYPES = (0, _immutable.List)([_messageTypes.ASSIGNMENT, _messageTypes.ASSIGNMENT_V2, _messageTypes.CONTEXT_UPDATE, _messageTypes.FILTERED_CHANGE, _messageTypes.CRM_OBJECT_LIFECYCLE_UPDATE, _messageTypes.CRM_OBJECT_WORKFLOW_EMAIL_SENT, _messageTypes.OPEN_THREAD, _messageTypes.CLOSE_THREAD]).concat(CONVERSATIONAL_MESSAGE_TYPES);